import { Component, Input, OnInit } from '@angular/core';
import { PageResult } from '@core/model/pagination/page-result';
import { States } from '@generated/queries';
import { ConvertDateUtcTimezoneService } from '@shared/services/convert-date-utc-timezone.service';
import { BusinessTimezoneService } from '@shared/services/business-timezone.service';
import { AssetAssignmentService } from '../../services/asset-assignment.service';
import { AssetAssignmentHistory } from '../../models/asset-assignment';

@Component({
  selector: 'app-asset-assignment-history',
  templateUrl: './asset-assignment-history.component.html',
  styleUrls: ['./asset-assignment-history.component.css'],
  standalone: false
})
export class AssetAssignmentHistoryComponent implements OnInit {

  @Input() tollDeviceId?: string;
  @Input() fuelCardId?: string;
  @Input() telematicDeviceId?: string;
  
  states = States; 
  businessTimeZone: string | null = null;
  assignmentHistory: PageResult<AssetAssignmentHistory> = new PageResult<AssetAssignmentHistory>();
  constructor(private assetAssignmentService: AssetAssignmentService,
    public utcToTimeZone: ConvertDateUtcTimezoneService,
        private businessTimezoneService: BusinessTimezoneService,
  ) { }

  async ngOnInit() {
    if (this.tollDeviceId) {
      this.getTollDeviceAssignmentHistory(this.tollDeviceId);
    }
    else if (this.fuelCardId) {
      this.getFuelCardAssignmentHistory(this.fuelCardId);
    }
    else if (this.telematicDeviceId) {
      this.getTelematicDeviceAssignmentHistory(this.telematicDeviceId);
    }
    await this.loadBusinessTimeZone();
  }

  private async loadBusinessTimeZone(): Promise<void> {
    this.businessTimeZone =
      await this.businessTimezoneService.getBusinessTimeZone();
  }

  getTollDeviceAssignmentHistory(tollDeviceId: string) {
    this.assetAssignmentService.getTollFleetAssignmentHistory(tollDeviceId).then(history => {
      this.assignmentHistory = history;
      console.log('Toll Device Fleet Assignment History:', history);
    }).catch(error => {
      console.error('Error fetching toll device fleet assignment history:', error);
    });
  }

  getFuelCardAssignmentHistory(fuelCardId: string) {
    this.assetAssignmentService.getFuelCardAssignmentHistory(fuelCardId).then(history => {
      this.assignmentHistory = history;
      console.log('Fuel Card Assignment History:', history);
    }).catch(error => {
      console.error('Error fetching fuel card assignment history:', error);
    });
  }

  getTelematicDeviceAssignmentHistory(telematicDeviceId: string) {
    this.assetAssignmentService.getTelematicDeviceAssignmentHistory(telematicDeviceId).then(history => {
      this.assignmentHistory = history;
      console.log('Telematic Device Assignment History:', history);
    }).catch(error => {
      console.error('Error fetching telematic device assignment history:', error);
    });
  }
}
